import type { Nullable } from 'common/types'

import { constructClientDispenser } from '../../clientDispenserFactory'
import { axiosInstance } from '../../common'
import type { UserSetting } from '../__generated__/data-contracts'
import { HttpClient } from '../__generated__/http-client'
import { UserSettingsClient } from '../__generated__/UserSettings'

const Clients = { UserSettingsClient }
const getClient = constructClientDispenser(Clients, HttpClient, axiosInstance)

export const getUserSettingsKeysApi = (): Promise<string[]> =>
  getClient('UserSettingsClient').userSettingsGetAllNames()

export const getUserSettingsByKeyApi = (key: string): Promise<Nullable<string>> =>
  getClient('UserSettingsClient')
    .userSettingsGetValue(key)
    .then(userSetting => userSetting.value ?? null)

export const setUserSettingsApi = (key: string, value: Nullable<string>): Promise<void> =>
  getClient('UserSettingsClient').userSettingsSetValue({ name: key, value })

export const getAllUserSettingsApi = (): Promise<UserSetting[]> =>
  getClient('UserSettingsClient').userSettingsGetAllSettings()
